import callApi from './backendService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;

export const activateKeyword = () => callApi({
  method: 'POST',
  endpoint: `${basePath}/push/activate_keyword_notification`,
});
